const getmovieDetails_Response = [
  {
    Status: "000",
    Message:
      "Tickets once sold are non-refundable, No rescheduling of seat, date, time or cinema",
    PromoCode: "",
    PromoAmount: 0,
    PromoType: "P",
    MinPromoAmount: 0.0,
    MaxPromoAmount: 0.0,
    MovieDates: [
      {
        ShowDates: "24 Aug 2022",
        ShowDetails: [
          {
            ShowID: "42947",
            ScreenID: "42947",
            ScreenName: "Screen 1",
            ScreenDescription: "Screen 1",
            ShowTime: "01:00 PM",
            TicketPrice: 720.0,
          },
          {
            ShowID: "42947",
            ScreenID: "42947",
            ScreenName: "Screen 1",
            ScreenDescription: "Screen 1",
            ShowTime: "01:00 PM",
            TicketPrice: 770.0,
          },
        ],
      },
      {
        ShowDates: "25 Aug 2022",
        ShowDetails: [
          {
            ShowID: "42969",
            ScreenID: "42969",
            ScreenName: "Screen 1",
            ScreenDescription: "Screen 1",
            ShowTime: "01:00 PM",
            TicketPrice: 570.0,
          },
          {
            ShowID: "42969",
            ScreenID: "42969",
            ScreenName: "Screen 1",
            ScreenDescription: "Screen 1",
            ShowTime: "01:00 PM",
            TicketPrice: 620.0,
          },
        ],
      },
    ],
  },
];

const seatLayout = [
  {
    Status: "000",
    MaxManualSeats: 0,
    Markup: 120.0,
    Message: "Select your Seats",
    SeatLayout: [
      {
        DisplayOrder: 0,
        MaxManualSeats: 0,
        Message: "Select",
        RowLayout: "w,0,0,0,0,0,0,0,0,0,w,w",
        RowName: "A",
        SeatPrice: "0,650,650,650,650,650,650,650,650,650,0,0",
        TicketCode:
          "0,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,0,0",
        SeatDescription:
          "0,Lounger,Lounger,Lounger,Lounger,Lounger,Lounger,Lounger,Lounger,Lounger,0,0",
        AllocatedSeats: [],
      },
      {
        DisplayOrder: 1,
        MaxManualSeats: 0,
        Message: "Select",
        RowLayout: "0,0,0,0,0,0,0,0,0,0,0,0",
        RowName: "B",
        SeatPrice: "600,600,600,600,600,600,600,600,600,600,600,600",
        TicketCode:
          "WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA",
        SeatDescription:
          "Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard",
        AllocatedSeats: [],
      },
      {
        DisplayOrder: 2,
        MaxManualSeats: 0,
        Message: "Select",
        RowLayout: "0,0,0,0,0,0,0,0,0,0,0,0",
        RowName: "C",
        SeatPrice: "600,600,600,600,600,600,600,600,600,600,600,600",
        TicketCode:
          "WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA",
        SeatDescription:
          "Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard",
        AllocatedSeats: [],
      },
      {
        DisplayOrder: 3,
        MaxManualSeats: 0,
        Message: "Select",
        RowLayout: "0,0,0,0,0,0,0,0,0,0,0,0",
        RowName: "D",
        SeatPrice: "600,600,600,600,600,600,600,600,600,600,600,600",
        TicketCode:
          "WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA",
        SeatDescription:
          "Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard",
        AllocatedSeats: [],
      },
      {
        DisplayOrder: 4,
        MaxManualSeats: 0,
        Message: "Select",
        RowLayout: "0,0,0,0,0,0,0,0,0,0,0,0",
        RowName: "E",
        SeatPrice: "600,600,600,600,600,600,600,600,600,600,600,600",
        TicketCode:
          "WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA",
        SeatDescription:
          "Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard",
        AllocatedSeats: [],
      },
      {
        DisplayOrder: 5,
        MaxManualSeats: 0,
        Message: "Select",
        RowLayout: "w,w,0,0,0,0,0,0,0,w,w,w",
        RowName: "F",
        SeatPrice: "0,0,650,650,650,650,650,650,650,0,0,0",
        TicketCode:
          "0,0,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,0,0,0",
        SeatDescription:
          "0,0,Lounger,Lounger,Lounger,Lounger,Lounger,Lounger,Lounger,0,0,0",
        AllocatedSeats: [],
      },
      {
        DisplayOrder: 6,
        MaxManualSeats: 0,
        Message: "Select",
        RowLayout: "w,0,0,0,0,0,0,0,0,0,w,w",
        RowName: "G",
        SeatPrice: "0,600,600,600,600,600,600,600,600,600,0,0",
        TicketCode:
          "0,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,0,0",
        SeatDescription:
          "0,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,0,0",
        AllocatedSeats: [],
      },
      {
        DisplayOrder: 7,
        MaxManualSeats: 0,
        Message: "Select",
        RowLayout: "w,0,0,0,0,0,0,0,0,0,w,w",
        RowName: "H",
        SeatPrice: "0,600,600,600,600,600,600,600,600,600,0,0",
        TicketCode:
          "0,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,0,0",
        SeatDescription:
          "0,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,0,0",
        AllocatedSeats: [],
      },
      {
        DisplayOrder: 8,
        MaxManualSeats: 0,
        Message: "Select",
        RowLayout: "w,0,0,0,0,0,0,0,0,0,w,w",
        RowName: "J",
        SeatPrice: "0,600,600,600,600,600,600,600,600,600,0,0",
        TicketCode:
          "0,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,0,0",
        SeatDescription:
          "0,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,0,0",
        AllocatedSeats: [],
      },
      {
        DisplayOrder: 9,
        MaxManualSeats: 0,
        Message: "Select",
        RowLayout: "w,0,0,0,0,0,0,0,0,0,w,w",
        RowName: "K",
        SeatPrice: "0,600,600,600,600,600,600,600,600,600,0,0",
        TicketCode:
          "0,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,0,0",
        SeatDescription:
          "0,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,0,0",
        AllocatedSeats: [],
      },
      {
        DisplayOrder: 10,
        MaxManualSeats: 0,
        Message: "Select",
        RowLayout: "w,0,0,0,0,0,0,0,0,0,0,w",
        RowName: "L",
        SeatPrice: "0,600,600,600,600,600,600,600,600,600,600,0",
        TicketCode:
          "0,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,0",
        SeatDescription:
          "0,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,0",
        AllocatedSeats: [],
      },
    ],
  },
];

export const testSeatLayout = [
  {
    DisplayOrder: 0,
    MaxManualSeats: 0,
    Message: "Select",
    RowLayout: "w,0,0,0,0,0,0,0,0,0,w,w",
    RowName: "A",
    SeatPrice: "0,650,650,650,650,650,650,650,650,650,0,0",
    TicketCode:
      "0,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,0,0",
    SeatDescription:
      "0,Lounger,Lounger,Lounger,Lounger,Lounger,Lounger,Lounger,Lounger,Lounger,0,0",
    AllocatedSeats: [],
  },
  {
    DisplayOrder: 1,
    MaxManualSeats: 0,
    Message: "Select",
    RowLayout: "0,0,0,0,0,0,0,0,0,0,0,0",
    RowName: "B",
    SeatPrice: "600,600,600,600,600,600,600,600,600,600,600,600",
    TicketCode:
      "WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA",
    SeatDescription:
      "Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard",
    AllocatedSeats: [],
  },
  {
    DisplayOrder: 2,
    MaxManualSeats: 0,
    Message: "Select",
    RowLayout: "0,0,0,0,0,0,0,0,0,0,0,0",
    RowName: "C",
    SeatPrice: "600,600,600,600,600,600,600,600,600,600,600,600",
    TicketCode:
      "WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA",
    SeatDescription:
      "Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard",
    AllocatedSeats: [],
  },
  {
    DisplayOrder: 3,
    MaxManualSeats: 0,
    Message: "Select",
    RowLayout: "0,0,0,0,0,0,0,0,0,0,0,0",
    RowName: "D",
    SeatPrice: "600,600,600,600,600,600,600,600,600,600,600,600",
    TicketCode:
      "WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA",
    SeatDescription:
      "Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard",
    AllocatedSeats: [],
  },
  {
    DisplayOrder: 4,
    MaxManualSeats: 0,
    Message: "Select",
    RowLayout: "0,0,0,0,0,0,0,0,0,0,0,0",
    RowName: "E",
    SeatPrice: "600,600,600,600,600,600,600,600,600,600,600,600",
    TicketCode:
      "WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA",
    SeatDescription:
      "Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard",
    AllocatedSeats: [],
  },
  {
    DisplayOrder: 5,
    MaxManualSeats: 0,
    Message: "Select",
    RowLayout: "w,w,0,0,0,0,0,0,0,w,w,w",
    RowName: "F",
    SeatPrice: "0,0,650,650,650,650,650,650,650,0,0,0",
    TicketCode:
      "0,0,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,0,0,0",
    SeatDescription:
      "0,0,Lounger,Lounger,Lounger,Lounger,Lounger,Lounger,Lounger,0,0,0",
    AllocatedSeats: [],
  },
  {
    DisplayOrder: 6,
    MaxManualSeats: 0,
    Message: "Select",
    RowLayout: "w,0,0,0,0,0,0,0,0,0,w,w",
    RowName: "G",
    SeatPrice: "0,600,600,600,600,600,600,600,600,600,0,0",
    TicketCode:
      "0,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,0,0",
    SeatDescription:
      "0,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,0,0",
    AllocatedSeats: [],
  },
  {
    DisplayOrder: 7,
    MaxManualSeats: 0,
    Message: "Select",
    RowLayout: "w,0,0,0,0,0,0,0,0,0,w,w",
    RowName: "H",
    SeatPrice: "0,600,600,600,600,600,600,600,600,600,0,0",
    TicketCode:
      "0,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,0,0",
    SeatDescription:
      "0,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,0,0",
    AllocatedSeats: [],
  },
  {
    DisplayOrder: 8,
    MaxManualSeats: 0,
    Message: "Select",
    RowLayout: "w,0,0,0,0,0,0,0,0,0,w,w",
    RowName: "J",
    SeatPrice: "0,600,600,600,600,600,600,600,600,600,0,0",
    TicketCode:
      "0,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,0,0",
    SeatDescription:
      "0,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,0,0",
    AllocatedSeats: [],
  },
  {
    DisplayOrder: 9,
    MaxManualSeats: 0,
    Message: "Select",
    RowLayout: "w,0,0,0,0,0,0,0,0,0,w,w",
    RowName: "K",
    SeatPrice: "0,600,600,600,600,600,600,600,600,600,0,0",
    TicketCode:
      "0,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,0,0",
    SeatDescription:
      "0,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,0,0",
    AllocatedSeats: [],
  },
  {
    DisplayOrder: 10,
    MaxManualSeats: 0,
    Message: "Select",
    RowLayout: "w,0,0,0,0,0,0,0,0,0,0,w",
    RowName: "L",
    SeatPrice: "0,600,600,600,600,600,600,600,600,600,600,0",
    TicketCode:
      "0,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,WKDAYDASA,0",
    SeatDescription:
      "0,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,Standard,0",
    AllocatedSeats: [],
  },
];

//Seats: [{ SeatPrice: "600", SeatNumber: "E4", TicketCode: "2156" }],
const reserveResponse = {
  Status: "000",
  ProviderID: "6166ebc5180b4",
  Name: "Century Imax Garden City",
  PerformanceID: "57785",
  SceenID: "57785",
  Message: "Seats reserved",
  Handler: "374458",
  Reservation: [
    {
      processServer: "A1WEB1",
      handle: "374458",
      timeout: "600",
      seatMap:
        "0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
      planCode: "41-1",
      mySeats: "139",
      profileTime: "0.35979318618774",
      profileStart: "20220823131147",
      profileEnd: "20220823131148",
    },
  ],
};

const createIntentResponse = {
  time: "2022-08-25T07:45:02.484Z",
  data: {
    reference: "b26ecc94-fa93-4f6a-b69e-38a4dc0d3c05",
    checkoutUrl: "http://0.0.0.0:3000/pay/b26ecc94-fa93-4f6a-b69e-38a4dc0d3c05",
    message: "Request processed successfully",
  },
};

const processPaymentResponse = {
  time: "2022-08-25T08:09:27.667Z",
  data: {
    status: "PENDING",
    message: "Payment received for processing",
    meta: {
      provider: "MPESA",
      providerReference: "",
      amount: 1,
      currency: "KES",
      description: "test timothy 3ds payment test",
      reference: "5d8131b7-46eb-4c22-ad99-8cbd0e9bc720",
    },
  },
};

const paymentStatusResponse = {
  time: "2022-08-25T08:18:55.013Z",
  data: {
    reference: "5d8131b7-46eb-4c22-ad99-8cbd0e9bc720",
    status: "PENDING",
    payload: {
      user: "tIMOTHY MPESA KIBE",
      payment: "My payment",
      another: "another",
      uniqueId: "fdfdfgdgd",
    },
    payment: {
      provider: "MPESA",
      details: null,
    },
    key: "movies/53234253",
    attempts: [
      {
        reference: "5d8131b7-46eb-4c22-ad99-8cbd0e9bc720",
        provider: "MPESA",
        status: "PENDING",
      },
    ],
    verification: null,
  },
};

export {
  getmovieDetails_Response,
  seatLayout,
  reserveResponse,
  createIntentResponse,
  processPaymentResponse,
  paymentStatusResponse,
};
